<template>
  <div>
    <div class="notice-detail ccui-app-container-detail">
      <div class="ccui-app-container-detail-body dic-ccui-form-biserial">
        <div class="notice-left">
          <div class="notice-title">
            {{
              schemeObj.schemeName
                ? schemeObj.schemeName
                : "中交一公局集团有限公司总承包经营分公司2021年8月商品混凝土集中招标采购流标公告"
            }}
          </div>
          <el-form>
            <el-row>
              <el-form-item label="项目编号：">{{
                schemeObj.schemeCode
              }}</el-form-item>
              <el-form-item label="发布时间：">{{
                schemeObj.noticeStartTime
              }}</el-form-item>
              <el-form-item label="发布单位：">{{
                schemeObj.opUnitName
              }}</el-form-item>
            </el-row>
          </el-form>
        </div>
        <div class="notice-atend">
          <p class="atend-time">报价结束剩余时间</p>
          <p class="atend-timeIcon">
            <span class="timeIcon"><img :src="timeImg" alt=""/></span>
            <span
              ><span class="day-color">{{ days }}</span
              >天<span class="day-color">{{ hours }}</span
              >时<span class="day-color">{{ minutes }}</span
              >分<span class="day-color">{{ seconds }}</span
              >秒</span
            >
          </p>
          <el-button
            v-if="$route_query.type !== '1'"
            size="mini"
            class="atendBtn"
            type="primary-icon-medium"
            @click="toParticipate"
            >立即报名</el-button
          >
        </div>
      </div>
    </div>
    <div class="template-detail-body ccui-clearfix">
      <div class="detail-box ccui-clearfix">
        <!--左侧内容-->
        <div class="detail-info mb20">
          <div class="ccui-app-container-detail">
            <div class="ccui-app-container-detail-body  dic-ccui-form-biserial">
              <div class="notice-detail-title">公告</div>
              <div class="tip">
                <!-- 公告标题： -->
                <!-- {{ $t("page.content.title") }} -->
                <p class="title mb20">
                  <span class="titleName">{{ $t("page.content.title") }}</span
                  >：{{ pageData.noticeTitle }}
                </p>
                <!-- 公告内容： -->
                <!-- {{ $t("page.content.Content") }} -->
                <p class="title">
                  <span class="titleName">{{ $t("page.content.Content") }}</span
                  >：<span v-html="pageData.textInfo"></span>
                </p>
              </div>

              <div class="notice-detail-title">
                附件列表<span @click="toBid" class="bidClass"
                  >供应商投标操作流程</span
                ><span class="view">(点击查看)</span>
              </div>
              <detailTable
                :tableData="pageData.fileinfoBOS"
                :tableHead="fileHead"
                :showIndex="true"
              ></detailTable>

              <!--包件信息-->
              <template v-for="(item, index) in packageList">
                <div :key="index">
                  <template v-if="subPackageFlag === '1'">
                    <div class="notice-detail-title">{{ item.packName }}</div>
                    <el-form>
                      <el-row>
                        <el-form-item label="包件说明：">{{
                          item.packRequire
                        }}</el-form-item>
                      </el-row>
                    </el-form>
                  </template>
                  <div class="notice-detail-title" v-else></div>
                  <template v-if="purchaseType != 53 && purchaseType != 50">
                    <el-group-title title="物资信息"></el-group-title>
                    <detailTable
                      :tableData="item.matDetailList"
                      :tableHead="packageHead"
                      :showIndex="true"
                    ></detailTable>
                  </template>
                </div>
              </template>

              <div class="notice-detail-title">相关公告列表</div>
              <detailTable
                :tableData="relateNoticeList"
                :tableHead="noticeHead"
                :showIndex="true"
              ></detailTable>
            </div>
          </div>
        </div>

        <!--右侧内容-->
        <div class="detail-info-right fl">
          <div class="notice-detail-box-in notice-detail-box-in-bg ">
            <div class="company-name-title">
              {{ schemeObj.opUnitName }}
            </div>
            <el-divider></el-divider>
            <div class="color-1">采购金额</div>
            <div>
              <span class="purchase-money ccui-mr-10">{{
                cumulativeAmount
              }}</span
              ><span class="color-1">万元</span>
            </div>
            <div class="color-1 pt15">
              累计采购项目<span class="pl20 pr-5">{{ projectNum }}</span
              >个
            </div>
            <div class="color-1 pt15">
              询价项目数量<span class="pl20 pr-5">{{ inquiryProjectNum }}</span
              >个
            </div>
            <div class="color-1 pt15">
              竞价项目数量<span class="pl20 pr-5">{{ competeProjectNum }}</span
              >个
            </div>
          </div>
        </div>
        <div class="color-1 fl ml20 mt15 mb5">该单位还在采购</div>
        <template v-for="(item, index) in otherNoticeList">
          <div class="detail-info-right1 fl  mb20" :key="index">
            <notice-item-block :data="item"></notice-item-block>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import timeImg from "@/basa/assets/images/timeRed.png";
import detailTable from "@/app/shop/components/detail-table";
import { commonTableWidth } from "@/setting/setting";
import noticeItemBlock from "@/app/shop/components/noticeItemBlock";
import MathNumerb from "@/basa/utils/MathNumerb";
import { operationManualUrl } from "@/setting/operationManualUrl.js";

import {
  qryNoticeDetail,
  queryProcessSchemeMatDetail,
  qryRelatedNoticeList,
  qryUnitAmountAndProjectNum,
  listOpUnitBidNotice
} from "@/app/myProjects/api/myProjects.js";
// import { addUrlPerFix } from "@/basa/utils";
import { setInterval, clearTimeout } from "timers";
export default {
  name: "noticeDetail",
  components: {
    detailTable,
    noticeItemBlock
  },
  data() {
    return {
      timeImg: timeImg,
      purchaseType: this.$route_query.purchaseType,
      currBreadCrumb: [{ title: "采购公告" }, { title: "" }],
      fileHead: [
        { label: "附件名称", prop: "fileName" },
        { label: "附件说明", prop: "fileSumm" },
        { label: "操作", slot: "opp", align: "center" }
      ],
      packageHead: [
        { label: "设备物资名称", prop: "matName" },
        { label: "设备物资说明", prop: "matDesc" },
        { label: "数量", prop: "convNum" },
        { label: "单位", prop: "convMeasureUnitName" }
      ],
      noticeHead: [
        { label: "类型", prop: "noticeTypeName", width: 150 },
        { label: "标题", prop: "noticeTitle" },
        { label: "环节", prop: "purStepName", width: 150 },
        {
          label: "发布时间",
          prop: "createTime",
          width: commonTableWidth.dateTimeWidth
        }
      ],
      subPackageFlag: "", //是否分包
      packageList: [],
      matDetailList: [],
      relateNoticeList: [], //相关公告列表
      schemeObj: {
        opUnitName: this.$route_query.opUnitName,
        schemeName: this.$route_query.schemeName,
        schemeCode: this.$route_query.schemeCode
      },
      pageData: {},
      cumulativeAmount: 0, //累计金额
      inquiryProjectNum: 0,
      competeProjectNum: 0,
      projectNum: 0, //项目数量
      otherNoticeList: [], //该单位还在采购的公告列表
      days: "0",
      hours: "0",
      minutes: "0",
      seconds: "0"
    };
  },
  // activated() {
  //   this.init();
  // },
  destroyed() {
    if (this.timeId) {
      clearTimeout(this.timeId);
    }
  },
  mounted() {
    this.init();
    this.getTime();
  },
  methods: {
    init() {
      let supCode = JSON.parse(sessionStorage.getItem("supInfo")).supCode;
      //查询公告信息及附件列表
      qryNoticeDetail({
        schemeId: this.$route_query.schemeId,
        noticeId: this.$route_query.noticeId,
        // purStep: 1,
        qryFileFlag: true
      }).then(res => {
        if (res.data.code === "0" && res.data.data) {
          this.pageData = res.data.data;
          this.currBreadCrumb[1].title = this.pageData.noticeTitle;
          this.schemeObj.noticeStartTime = this.pageData.noticeStartTime;
        }
      });
      //查询包件信息
      queryProcessSchemeMatDetail({
        schemeId: this.$route_query.schemeId
      }).then(res => {
        if (res.data.code === "0") {
          this.subPackageFlag = res.data.data.subPackageFlag;
          if (this.subPackageFlag === "0") {
            this.packageList = [{ matDetailList: res.data.data.matDetailList }];
          } else {
            this.packageList = res.data.data.packageList;
          }
        }
      });
      //查询相关公告列表
      qryRelatedNoticeList({
        schemeId: this.$route_query.schemeId,
        noticeId: this.$route_query.noticeId
      }).then(res => {
        if (res.data.code === "0") {
          this.relateNoticeList = res.data.data;
        }
      });

      // 单位累计金额和项目数量查询
      qryUnitAmountAndProjectNum({ opUnitId: this.$route_query.opUnitId }).then(
        res => {
          if (res.data.code === "0") {
            this.cumulativeAmount = MathNumerb.fmoney(
              res.data.data.cumulativeAmount,

              2
            );
            this.projectNum = res.data.data.projectNum;
            this.inquiryProjectNum = res.data.data.inquiryProjectNum;
            this.competeProjectNum = res.data.data.competeProjectNum;
          }
        }
      );

      //查询该单位还在采购的公告
      listOpUnitBidNotice({
        pageNo: 1,
        pageSize: 2,
        purchaseType: this.$route_query.purchaseType,
        opUnitId: this.$route_query.opUnitId,
        noticeId: this.$route_query.noticeId,
        supCode: supCode
      }).then(res => {
        if (res.data.code === "0") {
          this.otherNoticeList = res.data.data.rows;
        }
      });
    },
    // 报名
    toParticipate() {
      this.$router.push({
        path: "/shop/participate",
        query: {
          schemeId: this.$route_query.schemeId,
          purchaseType: this.$route_query.purchaseType,
          noticeStartTime: this.$route_query.noticeStartTime,
          schemeName: this.$route_query.schemeName,
          schemeCode: this.$route_query.schemeCode
        }
      });
    },
    // 投标流程
    toBid() {
      // window.open(
      //   `${this.$addUrlPerFix(
      //     // process.env.VUE_APP_SP_URL
      //     "sp.iccec.cn"
      //   )}/announcementDetail?id=372&source=1`
      // );
      // 替换新版操作手册
      const o = window.location;
      console.log(o);
      if (o.hostname === "localhost") {
        window.open(operationManualUrl.devUrl);
      } else {
        let arr = o.hostname.split("-");
        let perfix = arr.length === 1 ? "" : arr[0];
        console.log(perfix);
        if (perfix === "dev01") {
          window.open(operationManualUrl.devUrl);
        } else if (perfix === "test01") {
          window.open(operationManualUrl.testUrl);
        } else if (perfix === "uat01") {
          window.open(operationManualUrl.uatUrl);
        } else {
          window.open(operationManualUrl.prodUrl);
        }
      }
    },
    //计算剩余时间
    getTime() {
      let vals = new Date(this.$route_query.noticeEndTime.replace(/-/g, "/"));
      console.log(vals, "vals");
      this.timeId = setInterval(() => {
        var date2 = new Date(); //结束时间
        var date3 = vals.getTime() - date2.getTime(); //时间差的毫秒数
        if (date3 > 0) {
          // var subMinutes = Math.floor(date3 / (60 * 1000)); //获取总共的分钟差

          //计算出相差天数
          this.days = Math.floor(date3 / (24 * 3600 * 1000));

          //计算出小时数
          var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
          this.hours = Math.floor(leave1 / (3600 * 1000));
          //计算相差分钟数
          var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
          this.minutes = Math.floor(leave2 / (60 * 1000));
          //计算相差秒数

          var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数

          this.seconds = Math.round(leave3 / 1000);
        } else {
          this.days = 0;
          this.hours = 0;
          this.minutes = 0;
          this.seconds = 0;
        }
      }, 1000);
    }
  }
};
</script>

<style scoped lang="scss">
.template-detail-body .detail-box .detail-info {
  width: calc(100% - 240px);
  float: left;
}
/deep/ .template-detail-body .detail-box {
  margin-top: 5px;
  margin-bottom: 0;
}
/deep/.ccui-app-container-detail2 {
  padding-bottom: 0px;
  margin-top: 0px;
  min-height: 100vh;
  width: 100%;
}
</style>
